<template>
	<div class="app">
		<RouterView />
	</div>
</template>

<script lang="ts" setup>
import { onMounted, onBeforeUnmount } from 'vue';
import { useWebVitalsAnalytics } from '@/composables/analytics';

const { trackTTFB } = useWebVitalsAnalytics();
trackTTFB();

const dynamicAppHeight = () => {
	const doc = document.documentElement;
	doc.style.setProperty('--dynamic-app-height', `${window.innerHeight}px`);
};

onMounted(() => {
	window.addEventListener('resize', dynamicAppHeight);
	dynamicAppHeight();
});

onBeforeUnmount(() => {
	window.removeEventListener('resize', dynamicAppHeight);
});
</script>

<style lang="scss" scoped>
.app {
	height: calc(var(--dynamic-app-height));
}
</style>
